// Retain internal error codes for safe retry decisions, never user-facing
// diagnostic payloads. Investigation tracing is disabled in the normal app.
export const voiceTrace = () => {};
export const voiceError = (code, message) => Object.assign(new Error(message), { code });